import { Component, Input, OnInit } from "@angular/core";
import {
  NgbModal,
  NgbActiveModal,
  NgbDateStruct,
  NgbCalendar,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";

@Component({
  selector: "app-tache-detail",
  templateUrl: "./tache-detail.component.html",
  styleUrls: ["./tache-detail.component.scss"],
})
export class TacheDetailComponent implements OnInit {
  errorMessage: String = null;

  @Input() taskKey;
  @Input() taskName;

  constructor(private _router: Router, public activeModal: NgbActiveModal) {}

  ngOnInit() {}
}
